<template>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center;" class="p-0">
        <div class="container-box center">
          <div class="text-left">
            <div class="card-custom-web">
              <br />

              <div class="float-left ml-3 mt-3">
                <strong class="custom-text-hotpick ml-1">Bills</strong>
              </div>

     

              <div class="float-right mr-3 mt-3">
                <strong class="custom-text-viewall mr-1">
                    Pay All
                </strong>
              </div>
              <br /> <br /> <br />
              <div style="clear: both"></div>

              <div v-for="item in paymentList" v-bind:key="item.id">
                <div v-if="item.isPaid == false">
                  <CCard class="ml-3 mr-3">
                    <CCardBody>
                      <div class="float-left">    
                        <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"><strong> {{ item.studentName }} </strong></label>            
                        <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;"> {{ item.note }} </label>
                        <label style="font-size: 15px; color: #000A2C; font-weight: 750; display: flex;"><strong> {{ user.currencyCode }} {{ item.paymentFee }} </strong></label>   
                      </div>
                      <div class="float-right" style="margin-top: 50px">
                        <CBadge style="width: 80px" class="custom-badge-payment-unpaid mr-2" @click="PopupDetail(item.id)">
                          Pay Now
                        </CBadge>
                        <!-- <span class="custom-topup" @click="PopupDetail(item.id)">
                          <label class="ml-3 mr-2" >Details</label>
                        </span> -->
                      </div>
                    </CCardBody>
                  </CCard>
                </div>

                <div v-else>
                  <CCard class="ml-3 mr-3" @click="PopupDetail(item.id)">
                    <CCardBody>
                      <div class="float-left">    
                        <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"><strong> {{ item.studentName }} </strong></label>            
                        <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;"> {{ item.note }} </label>
                        <label style="font-size: 15px; color: #000A2C; font-weight: 750; display: flex;"><strong> {{ user.currencyCode}} {{ item.paymentFee }} </strong></label>   
                      </div>
                      <div class="float-right" style="margin-top: 50px">
                        <CBadge style="width: 80px;" class="custom-badge-payment-paid mr-2" @click="PopupDetail(item.id)">
                          Bill Paid
                        </CBadge>
                        <!-- <span class="custom-topup" @click="PopupDetail(item.id)">
                          <label class="ml-3 mr-2" >Details</label>
                        </span> -->
                      </div>
                    </CCardBody>
                  </CCard>
                </div>
              </div>

            </div>

            <CModal title="Packages" style="
              position: relative;
              width: 375px;
              height: 454px;
              border-radius: 32px;" size="" :show.sync="detailpopup">
              
              <CCard class="p-3" >
                <CRow v-for="item in details.paymentDescriptionList" v-bind:key="item.id">
                  <CCol class="" md="10" style="width: 80%;"> {{ item.packageName }} </CCol>
                  <CCol class=""> {{ item.packageFee }} </CCol>
                  <hr />
                </CRow>
                <hr />
                <CRow>
                  <CCol class="" md="10" style="width: 80%; font-weight: 600;"> Total </CCol>
                  <CCol class=""> 
                    <span v-for="paym in paymentList" v-bind:key="paym.id">
                      <span v-if="paym.id === payId">
                        {{ paym.paymentFee }} 
                      </span>
                    </span>
                  </CCol>
                </CRow>
              </CCard>
              <!-- <div v-if="details.isPaid == true">
              
              </div> -->
              <template #footer v-if="details.isPaid == false">
                <CButton color="info" @click="submitPay(payId)">Pay Now</CButton>
              </template>
              <template #footer v-else>
                <CButton color="info" @click="closePopup()">Close</CButton>
              </template>
            </CModal>

          </div>
        </div>
      </CContainer>

      
      <div class="header-top" style="max-width: 750px;">
        Pay Bill 
        <br /> <br /> <br />
        <!-- <div class="" style="margin-top: 70px"> -->
        <CCarousel arrows indicators animate class="d-sm-down-none">
          <CCarouselItem>
            <!-- carousel 1 -->
            <CRow>
              <CCard class="ml-3 mr-3" style="width: 46%;">
                <CCardBody style="padding: 5px;">
                  <div class="float-left ml-2">                  
                    <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;">Total Unpaid</label>
                    <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"><strong> Amount to pay </strong></label>
                    <label style="font-size: 15px; color: #F85954; font-weight: 700; display: flex;"><strong> {{ user.currencyCode }}  {{ payment.totalUnpaid }}</strong></label>
                  </div>
                  <div class="float-right mr-4">
                      <img src="../../assets/img/icon/unpaid-money.svg"/>
                  </div>
                </CCardBody>
              </CCard>

              <CCard class="ml-2 mr-3" style="width: 46%;">
                <CCardBody style="padding: 5px;">
                  <div class="float-left ml-2">                  
                    <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;" >Total Paid</label>
                    <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"><strong> Amount paid </strong></label>
                    <label style="font-size: 15px; color: #95DB00; font-weight: 700; display: flex;"><strong> {{ user.currencyCode }} {{ payment.totalPaid }} </strong></label>
                  </div>
                  <div class="float-right mr-4">
                      <img src="../../assets/img/icon/unpaid-money.svg"/>
                  </div>
                </CCardBody>
              </CCard>
            </CRow>
          </CCarouselItem>
        
          <!-- <CCarouselItem>
            !-- carousel 1 --
            <CCard class="ml-3 mr-3">
              <CCardBody style="padding: 5px;">
                <div class="float-left ml-2">                  
                  <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;" >Total Paid</label>
                  <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"><strong> Amount paid </strong></label>
                  <label style="font-size: 15px; color: #95DB00; font-weight: 700; display: flex;"><strong> RM 150.00 </strong></label>
                </div>
                <div class="float-right mr-4">
                    <img src="../../assets/img/icon/unpaid-money.svg"/>
                </div>
              </CCardBody>
            </CCard>
          </CCarouselItem> -->
        </CCarousel>

        <CCarousel arrows indicators animate class="d-sm-flex d-md-none">
          <CCarouselItem>
            <!-- carousel 1 -->
            <CCard class="ml-3 mr-3">
              <CCardBody style="padding: 5px;">
                <div class="float-left ml-2">                  
                  <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;">Total Unpaid</label>
                  <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"> Amount to pay </label>
                  <label style="font-size: 15px; color: #F85954; font-weight: 700; display: flex;"> RM {{ payment.totalUnpaid }} </label>
                </div>
                <div class="float-right mr-4">
                    <img src="../../assets/img/icon/unpaid-money.svg"/>
                </div>
              </CCardBody>
            </CCard>
          </CCarouselItem>
        
          <CCarouselItem>
            <!-- carousel 1 -->
            <CCard class="ml-3 mr-3">
              <CCardBody style="padding: 5px;">
                <div class="float-left ml-2">                  
                  <label style="font-size: 10px; color: #000A2C; font-weight: 500; display: flex;" >Total Paid</label>
                  <label style="font-size: 15px; color: #000A2C; font-weight: 700; display: flex;"> Amount paid </label>
                  <label style="font-size: 15px; color: #95DB00; font-weight: 700; display: flex;"> RM {{ payment.totalPaid }} </label>
                </div>
                <div class="float-right mr-4">
                    <img src="../../assets/img/icon/unpaid-money.svg"/>
                </div>
              </CCardBody>
            </CCard>
          </CCarouselItem>
        </CCarousel>
      </div>

      <div class="header-left">
        <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
      </div>
  
      <div style="clear: both"></div>
    </div>
  </template>
  
  
  
  <script>
  import Vue from "vue";
  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
  } from "hooper";
  
  import MainlayoutBottom from "../../containers/TheBottomCustom.vue";
  Vue.use(require("vue-moment"));
  
  import "hooper/dist/hooper.css";
  
  export default {
    name: "Profile",
    e1: "#app",
    components: {
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination,
      MainlayoutBottom,
    },
  
    data: function () {
      return {
        user: {},
        // studentProfileAuthorize: "",
        // childProfileAuthorize: "",
        // childs: [],
        // parent: [],
        // students: [],
        // wallet: {},
        payment: {},
        paymentList: [],
        details: {},
        detailpopup: false,
        payId: "",
        hooperSettings: {
          itemsToShow: 2,
          centerMode: true,
          breakpoints: {
            800: {
              centerMode: false,
            },
            1000: {
              pagination: "fraction",
            },
          },
        },
        
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },

    // computed: {
    //   sumValuePackage(){
    //     return this.details.paymentDescriptionList.reduce((acc, item) => acc + item.packageFee, 0);
    //   }
    // },

    methods: {
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              this.GetTotalPaidAndUnpaid(this.user.id);
              this.GetPaymentList(this.user.id);
              // this.GetPaymentListDetails(this.$route.query.paymentId);
            }
          });
      },
      
      GetTotalPaidAndUnpaid() {
      this.$API
        .get(this.$TotalPaidAndUnpaid + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.payment = response.data;
          }
        });
      },

      GetPaymentList() {
      this.$API
        .get(this.$PaymentListByStudent + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.paymentList = response.data;
          }
        });
      },

      // GetPaymentListDetails() {
        // for (let index = 0; index < this.paymentList.length; index++) {
        //   var set = this.paymentList[index];
        //   console.log("try", set);
        //   this.$API
        //   .get(this.$PaymentListDetails + "?id=" + this.paymentList.id, {
        //     withCredentials: true,
        //   })
        //   .then((response) => {
        //     if (response.status == 200 && response.data != null) {
        //       this.details = response.data;
        //     }
        //   });
        // },
      // }
      

      PopupDetail(id) {
        this.payId = id;
        this.$API
          .get(this.$PaymentListDetails + "?id=" +id, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.details = response.data;
            }
          });

        this.detailpopup = true;
      },

      closePopup() {
        this.detailpopup = false;
      },

      submitPay(idpay) {
        const formData = new FormData();

        formData.append("id", idpay);

        return this.$API
        .post(this.$UpdateKiddoPayPaymentDataWeb, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if(response.status == 200 && response.data != null) {
            this.billId = response.data;
            window.open("https://www.billplz.com/bills/" + this.billId,"_self");

          } else {
            this.Message = response.data.Message;
            this.ErrorMessage = true;
          }
          
        })
        .catch((error) => {
          if (error.response) {
              console.log(error.response.data);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
              this.Message = response.data.Message;
              this.ErrorMessage = true;
            }
        });
      },

      GoToBillPayment() {
        this.$router.push("/ParentProfile/BillPayment");
      },

      GoBack() {
      this.$router.back();
    },
      
    },
  };
  </script>  
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
  
  input {
    border-bottom: 2px solid #dbdbdb;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
  }
  
  input ::placeholder {
    color: #e0e0e0;
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #e0e0e0;
  }
  .c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  .custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
  
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  body {
    font-family: "Montserrat", sans-serif;
  }
  .card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 180px;
  height: fit-content;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
  }
  .images {
    height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
  }
  .img1 {
    background: salmon;
  }
  .img2 {
    background: lightblue;
  }
  .img3 {
    background: coral;
  }
  .img4 {
    background: lightgreen;
  }
  .img5 {
    background: pink;
  }
  h2 {
    color: #fff;
  }
  .hooper-pagination {
    display: none;
  }
  .hooper {
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: auto;
  }
  .progress {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 1rem;
    overflow: hidden;
    line-height: 0;
    font-size: 0.65625rem;
    border-radius: 0.25rem;
    background-color: #ebedef;
    height: 5px;
    border-radius: 10px;
  }
  </style>